var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ejs-textbox',{attrs:{"placeholder":"Enter...","multiline":true,"value":_vm.data.answerAdditionalInformation,"maxlength":250,"rows":5},on:{"change":function($event){return _vm.onChange($event.value)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }